import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { Grid2, Stack } from '@mui/material';

export default function LogSymbolsModal({ openSymbols, setOpenSymbols }) {
  const { t } = useTranslation();
  const symbolsInfo = openSymbols;
  const id = openSymbols.indx;
  const title = `#${id} ${t('Dropped symbols')}, ${t('spin')} ${symbolsInfo.spin}`;
  const getUrl = (id) => window.origin + `/images/symbols/${symbolsInfo.game}/${id}.jpg`;

  return (
    <InfoDialog
      open={openSymbols}
      onClose={() => setOpenSymbols(false)}
      title={title}
      maxWidth="sm">
      <Grid2 container>
        {symbolsInfo.syms?.map((symList, indx) => (
          <Grid2 size={12 / 5} key={indx}>
            {symList.map((sym, indx2) => (
              <Grid2 size={12} key={`${indx}_${indx2}`}>
                <img width={'100%'} src={getUrl(sym)} />
              </Grid2>
            ))}
          </Grid2>
        ))}
      </Grid2>
    </InfoDialog>
  );
}
